// Must match exactly what the API returns in moduli arrays
export const ROLES = {
  GLOBALNI_ADMINISTRATOR: "globalniAdministrator",
  GLOBALNI_OBISKOVALEC: "globalniObiskovalec",
  GLOBALNI_UREDNIK: "globalniUrednik",
  GLOBALNI_NI_DOSTOPA: "globalniNiDostopa",
  FAKULTETNI_SKRBNIK: "fakultetniSkrbnik",
  UPORABNIK: "uporabnik",
  // TODO: add more roles here
};

// ─── Role Groups ──────────────────────────────────────────────────────────────
// Predefined combinations for use in RoleGuard
export const ROLE_GROUPS = {
  ALL: [
    ROLES.GLOBALNI_OBISKOVALEC,
    ROLES.GLOBALNI_UREDNIK,
    ROLES.GLOBALNI_ADMINISTRATOR,
    ROLES.UPORABNIK,
    ROLES.FAKULTETNI_SKRBNIK,
  ],
  EDITORS: [ROLES.GLOBALNI_UREDNIK, ROLES.GLOBALNI_ADMINISTRATOR],
  EDITORS_AND_SKRBNIK: [
    ROLES.GLOBALNI_UREDNIK,
    ROLES.GLOBALNI_ADMINISTRATOR,
    ROLES.FAKULTETNI_SKRBNIK,
  ],
  GLOBALNI: [
    ROLES.GLOBALNI_OBISKOVALEC,
    ROLES.GLOBALNI_UREDNIK,
    ROLES.GLOBALNI_ADMINISTRATOR,
  ],
  GLOBALNI_AND_FAKULTETNI: [
    ROLES.GLOBALNI_OBISKOVALEC,
    ROLES.GLOBALNI_UREDNIK,
    ROLES.GLOBALNI_ADMINISTRATOR,
    ROLES.FAKULTETNI_SKRBNIK,
  ],
  GLOBALNI_ADMINISTRATOR_AND_SKRBNIK: [
    ROLES.GLOBALNI_ADMINISTRATOR,
    ROLES.FAKULTETNI_SKRBNIK,
  ],
};

// ─── Module Keys ──────────────────────────────────────────────────────────────
// Must match exactly the keys returned in userRole.moduli from the API
export const MODULES = {
  PROGRAMI: "programi",
  PROJEKTI: "projekti",
  RAZPISI: "razpisi",
  PARTNERJI: "partnerji",
  AKTUALNI_RAZPISI: "aktualniRazpisi",
  DEMINIMIS: "deminimis",
  AVTORIZACIJE: "avtorizacije",
  REVIZIJSKA_SLED: "revizijskaSled",
  IZPISI: "izpisi",
  IZPISI_CLANICE: "izpisiClanice",
  SIFRANTI: "sifranti",
};
